export default __webpack_public_path__ + "static/media/job-management.2439cd1d.svg";